export enum PathEnum {
    Home = '/',
    Soon = '/soon/',
    Contact = '/contact/',
    Services = '/services/',
    About = '/about/',
    FAQ = '/faq/',
    Returns = '/returns/',
    Impressum = '/impressum',
    TermsOfService = '/terms-of-service/',
    PrivacyPolicy = '/privacy-policy/',
    Partners = '/partners/',
    LaserCutting = '/service/laser-cutting/',
    Grinding = '/service/grinding/',
    Turning = '/service/turning/',
    Milling = '/service/milling/',
    WaterJetCutting = '/service/water-jet-cutting/',
    Welding = '/service/welding/',
    Construction3D = '/service/3d-construction/',
    Bending = '/service/bending/',
    Punching = '/service/punching/',
    EDM = '/service/edm/',
    NotFound = '/not-found/',
}

export enum ServiceNameEnum {
    LaserCutting = 'laserCutting',
    Grinding = 'grinding',
    Turning = 'turning',
    Milling = 'milling',
    WaterJetCutting = 'waterJetCutting',
    Welding = 'welding',
    Construction3D = '3dConstruction',
    Bending = 'bending',
    Punching = 'punching',
    EDM = 'edm',
}

export enum FooterLinkEnum {
    Returns = 'returns',
    FAQ = 'faq',
    About = 'about',
    Partners = 'partners',
    Services = 'services',
}

export enum ProductOpenedOptionEnum {
    Yes = 'yes',
    No = 'no',
}

export enum ReasonForReturnOptionEnum {
    DeadOnArrival = 'deadOnArrival',
    OrderError = 'orderError',
    Faulty = 'faulty',
    WrongItem = 'wrongItem',
}

export enum AboutSectionTabEnum {
    AboutUs = 'about-us',
    QualityAssurance = 'quality-assurance',
    DataSecurity = 'data-security',
    Q1Supplier = 'q1-supplier',
}

export enum AboutServiceSectionTabEnum {
    Service = 'service',
    Process = 'process',
    Specifications = 'specifications',
    Utilizations = 'utilizations',
}
